/**
 * Greenleaze Product Page Handler
 * Gère l'affichage conditionnel des éléments de location sur la page produit
 * quand l'utilisateur provient d'une collection de location
 */

(function () {
  "use strict";

  // Vérifier si l'utilisateur vient d'une collection location
  function isFromLocationCollection() {
    const referrer = document.referrer;

    // Vérifier si le referrer contient "location" dans l'URL
    if (
      referrer &&
      (referrer.includes(
        "/collections/tous-nos-velos-electriques-reconditionnes-en-location",
      ) ||
        (referrer.includes("location") && referrer.includes("/collections/")))
    ) {
      console.log(
        "[Greenleaze Product Page] User came from location collection:",
        referrer,
      );
      return true;
    }

    // Vérifier le sessionStorage (au cas où l'utilisateur navigue)
    try {
      const fromLocation = sessionStorage.getItem("fromLocationCollection");
      if (fromLocation === "true") {
        console.log(
          "[Greenleaze Product Page] User session indicates location collection",
        );
        return true;
      }
    } catch (e) {
      console.warn(
        "[Greenleaze Product Page] Could not access sessionStorage:",
        e,
      );
    }

    return false;
  }

  // Marquer la session si on est sur une collection location
  function markLocationSession() {
    if (
      window.location.pathname.includes("/collections/") &&
      window.location.pathname.includes("location")
    ) {
      try {
        sessionStorage.setItem("fromLocationCollection", "true");
        console.log(
          "[Greenleaze Product Page] Marked session as from location collection",
        );
      } catch (e) {
        console.warn(
          "[Greenleaze Product Page] Could not set sessionStorage:",
          e,
        );
      }
    }
  }

  // Réorganiser les boutons sur la page produit
  function reorganizeProductButtons() {
    console.log("[Greenleaze Product Page] Reorganizing buttons...");

    const addToCartContainer = document.querySelector(".add_to_cart_holder");
    const greenleazeButton = document.querySelector(
      ".greenleaze-button-product",
    );
    const addToCartButton = document.querySelector(
      ".single-add-to-cart-button",
    );

    if (!addToCartContainer || !greenleazeButton || !addToCartButton) {
      console.warn(
        "[Greenleaze Product Page] Could not find required elements",
      );
      return;
    }

    // Déplacer le bouton Greenleaze avant le bouton "Ajouter au panier"
    addToCartContainer.insertBefore(greenleazeButton, addToCartButton);

    // Ajouter une classe pour le style
    addToCartContainer.classList.add("location-mode");
    greenleazeButton.classList.add("primary-action");
    addToCartButton.classList.add("secondary-action");

    // Ajouter le prix au bouton "Ajouter au panier"
    updateAddToCartButtonPrice();

    console.log("[Greenleaze Product Page] Buttons reorganized successfully");
  }

  // Ajouter le prix au bouton "Ajouter au panier"
  function updateAddToCartButtonPrice() {
    const addToCartButton = document.querySelector(
      ".single-add-to-cart-button",
    );
    const priceElement = document.querySelector(
      ".price .amount.discounted, .price .amount",
    );

    if (!addToCartButton || !priceElement) return;

    const buttonText = addToCartButton.querySelector(
      ".single-add-to-cart-button--text",
    );
    if (!buttonText) return;

    const priceText = priceElement.textContent.trim();
    const originalText = buttonText.textContent
      .trim()
      .replace(/\s*\(.*?\)\s*$/, ""); // Enlever l'ancien prix s'il existe

    buttonText.textContent = `${originalText} (${priceText})`;

    // Écouter les changements de variant pour mettre à jour le prix
    document.addEventListener("variant:change", function (event) {
      if (event.detail && event.detail.variant) {
        const newPrice = event.detail.variant.price;
        const formattedPrice = (newPrice / 100).toFixed(2).replace(".", ",");
        buttonText.textContent = `${originalText} (${formattedPrice}€)`;
      }
    });
  }

  // Remplacer le prix par le sélecteur Greenleaze
  function replacePriceWithSelector() {
    console.log(
      "[Greenleaze Product Page] Replacing price with duration selector...",
    );

    // Chercher le conteneur greenleaze (où se trouve le bouton)
    const greenleazeContainer = document.querySelector(
      ".greenleaze-product-container",
    );

    if (!greenleazeContainer) {
      console.warn("[Greenleaze Product Page] Greenleaze container not found");
      return;
    }

    console.log(
      "[Greenleaze Product Page] Greenleaze container found:",
      greenleazeContainer,
    );

    // Masquer le prix original dans le conteneur de prix en haut
    const priceContainer = document.querySelector(
      ".product-price-container, .product-title-container .product-price-container",
    );

    if (priceContainer) {
      const priceElement = priceContainer.querySelector(".price");
      if (priceElement) {
        priceElement.style.display = "none";
        priceElement.classList.add("hidden-for-location");
      }

      const installmentForm = priceContainer.querySelector(
        ".installment, form[id*='installment']",
      );
      if (installmentForm) {
        installmentForm.style.display = "none";
        installmentForm.classList.add("hidden-for-location");
      }

      const noJsHidden = priceContainer.querySelector(".no-js-hidden");
      if (noJsHidden) {
        noJsHidden.style.display = "none";
        noJsHidden.classList.add("hidden-for-location");
      }
    }

    // Ajouter une classe au conteneur pour identifier le mode location
    greenleazeContainer.classList.add("location-mode");

    // Cacher le bouton greenleaze original
    const originalButton = greenleazeContainer.querySelector(
      ".greenleaze-button-product:not(.greenleaze-button-integrated)",
    );
    if (originalButton) {
      originalButton.style.display = "none";
    }

    // Ajouter la classe outline au bouton Ajouter au panier en mode location
    const addToCartButton = document.querySelector(
      "#AddToCart.single-add-to-cart-button",
    );
    if (addToCartButton) {
      addToCartButton.classList.remove("accent");
      addToCartButton.classList.add("outline");
    }

    // Vérifier si le sélecteur existe déjà
    let selectorContainer = greenleazeContainer.querySelector(
      ".greenleaze-product-selector-wrapper",
    );

    if (!selectorContainer) {
      // Créer le conteneur pour le sélecteur
      selectorContainer = document.createElement("div");
      selectorContainer.className = "greenleaze-product-selector-wrapper";

      // Insérer au début du conteneur greenleaze (avant le bouton)
      greenleazeContainer.insertBefore(
        selectorContainer,
        greenleazeContainer.firstChild,
      );

      // Récupérer le product ID depuis le script JSON
      let productId = null;
      let productData = null;

      const productJsonScript = document.querySelector(
        "script[data-product-json]",
      );

      if (productJsonScript) {
        try {
          productData = JSON.parse(productJsonScript.textContent);
          productId = productData.id;
          console.log("[Greenleaze Product Page] Product data loaded:", {
            id: productId,
            title: productData.title,
          });
        } catch (e) {
          console.error(
            "[Greenleaze Product Page] Could not parse product JSON:",
            e,
          );
        }
      } else {
        console.warn("[Greenleaze Product Page] Product JSON script not found");
      }

      console.log("[Greenleaze Product Page] Product ID:", productId);

      if (productId && productData) {
        // Créer le sélecteur dynamiquement
        createDurationSelector(selectorContainer, productId, productData);
      } else {
        console.error(
          "[Greenleaze Product Page] Could not find product ID or data",
        );
      }
    }

    console.log(
      "[Greenleaze Product Page] Selector added to greenleaze container",
    );
  }

  // Créer le sélecteur de durée dynamiquement
  function createDurationSelector(container, productId, productData) {
    // Récupérer le prix du variant sélectionné
    let productPrice = 0;

    // Récupérer le variant actuel
    const variantInput = document.querySelector('input[name="id"]');
    const currentVariantId = variantInput ? parseInt(variantInput.value) : null;

    if (currentVariantId && productData.variants) {
      const variant = productData.variants.find(
        (v) => v.id === currentVariantId,
      );
      if (variant) {
        productPrice = variant.price;
        console.log(
          "[Greenleaze Product Page] Using variant price:",
          productPrice,
        );
      }
    }

    // Fallback: premier variant ou price du produit
    if (!productPrice) {
      if (productData.variants && productData.variants.length > 0) {
        productPrice = productData.variants[0].price;
        console.log(
          "[Greenleaze Product Page] Using first variant price:",
          productPrice,
        );
      } else if (productData.price) {
        productPrice = productData.price;
        console.log(
          "[Greenleaze Product Page] Using product price:",
          productPrice,
        );
      }
    }

    console.log(
      "[Greenleaze Product Page] Product price for selector:",
      productPrice,
    );

    container.innerHTML = `
      <div class="greenleaze-product-selector" data-product-id="${productId}" data-product-price="${productPrice}">
        <div class="greenleaze-product-price-display">
          <span class="greenleaze-product-monthly-price" id="greenleaze-product-price-${productId}">
            <span class="greenleaze-loading">Chargement...</span>
          </span>
          <span class="greenleaze-product-price-label" style="display: none;">par mois</span>
        </div>
        <div class="greenleaze-product-duration-buttons" id="greenleaze-product-buttons-${productId}">
        </div>
      </div>
      <button
        type="button"
        class="greenleaze-button greenleaze-button-product greenleaze-button-integrated primary-action"
        id="greenleaze-badge"
        data-price="${productPrice}"
        data-duration="36"
        data-value="3"
        data-type="cart"
      >
        Louer dès maintenant
      </button>
    `;

    // Initialiser le sélecteur Greenleaze
    initializeGreenleazeSelector(productId, productPrice);

    // Initialiser le bouton de location intégré
    const integratedButton = container.querySelector(
      ".greenleaze-button-integrated",
    );
    if (integratedButton) {
      integratedButton.addEventListener("click", function (event) {
        // Empêcher la propagation de l'événement pour éviter que le formulaire ne soit soumis
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const modal = document.querySelector(
          "#modal-abonnement-product--greenleaze",
        );
        if (modal) {
          modal.style.display = "block";
        }
      });
    }
  }

  // Initialiser le sélecteur Greenleaze
  function initializeGreenleazeSelector(productId, initialPrice) {
    let productPrice = initialPrice;
    let selectedDuration = 36;

    function initSelector() {
      if (
        !window.initPrice ||
        !window.monthValues ||
        !window.getRuleByProductPriceAndDuration
      ) {
        console.warn(
          "[Greenleaze Product Page] Greenleaze not ready, retrying...",
        );
        setTimeout(initSelector, 500);
        return;
      }

      console.log(
        "[Greenleaze Product Page] Initializing selector for product:",
        productId,
      );

      const priceDisplay = document.getElementById(
        `greenleaze-product-price-${productId}`,
      );
      const buttonsContainer = document.getElementById(
        `greenleaze-product-buttons-${productId}`,
      );

      if (!priceDisplay || !buttonsContainer) {
        console.warn("[Greenleaze Product Page] Selector elements not found");
        return;
      }

      // Créer les boutons de durée
      buttonsContainer.innerHTML = "";
      window.monthValues.forEach((duration, index) => {
        const button = document.createElement("button");
        button.type = "button";
        button.className = "greenleaze-product-duration-btn";
        button.dataset.duration = duration;
        button.textContent = `${duration}m`;

        if (index === window.monthValues.length - 1) {
          // Sélectionner 36m par défaut (dernière durée = prix le plus bas)
          button.classList.add("active");
          selectedDuration = duration;
        }

        button.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();

          buttonsContainer
            .querySelectorAll(".greenleaze-product-duration-btn")
            .forEach((btn) => {
              btn.classList.remove("active");
            });

          this.classList.add("active");
          selectedDuration = duration;
          updatePrice(duration);
        });

        buttonsContainer.appendChild(button);
      });

      updatePrice(selectedDuration);
    }

    function updatePrice(duration) {
      const prixHT = (productPrice / 100) * (5 / 6);
      const priceDisplay = document.getElementById(
        `greenleaze-product-price-${productId}`,
      );
      const priceLabel = priceDisplay?.parentElement?.querySelector(
        ".greenleaze-product-price-label",
      );

      if (!priceDisplay) {
        console.warn("[Greenleaze Product Page] Price display not found");
        return;
      }

      try {
        const rule = window.getRuleByProductPriceAndDuration(prixHT, duration);
        console.log(
          "[Greenleaze Product Page] Rule for duration",
          duration,
          ":",
          rule,
        );
        if (rule && rule.monthly) {
          priceDisplay.textContent = `${rule.monthly}€`;
          if (priceLabel) priceLabel.style.display = "";
        } else {
          console.warn(
            "[Greenleaze Product Page] No rule found for price:",
            prixHT,
          );
        }
      } catch (e) {
        console.error("[Greenleaze Product Page] Error updating price:", e);
        priceDisplay.textContent = "Prix non disponible";
      }
    }

    // Écouter les changements de variant
    document.addEventListener("variant:change", function (event) {
      if (event.detail && event.detail.variant) {
        productPrice = event.detail.variant.price;
        console.log(
          "[Greenleaze Product Page] Variant changed, new price:",
          productPrice,
        );
        updatePrice(selectedDuration);
      }
    });

    // Démarrer l'initialisation
    if (window.init === true) {
      initSelector();
    } else {
      window.addEventListener("greenleazePriceActualize", initSelector);
    }
  }

  // Masquer la carte de paiement en plusieurs fois
  function hidePaymentInstalmentsCard() {
    console.log("[Greenleaze Product Page] Hiding payment instalments card...");

    const instalmentsCard = document.querySelector(".loewi-alma-card");

    if (instalmentsCard) {
      instalmentsCard.style.display = "none";
      instalmentsCard.classList.add("hidden-for-location");
      console.log("[Greenleaze Product Page] Payment instalments card hidden");
    } else {
      console.warn(
        "[Greenleaze Product Page] Payment instalments card not found",
      );
    }
  }

  // Ajouter les styles CSS
  function addStyles() {
    const style = document.createElement("style");
    style.textContent = `
      /* Masquer tous les éléments de prix en mode location */
      body.template-product .product-price-container .hidden-for-location,
      body.template-product .product-price-container .price.hidden-for-location,
      body.template-product .product-price-container .no-js-hidden.hidden-for-location,
      body.template-product .product-price-container form.installment.hidden-for-location,
      body.template-product .product-price-container [id*="installment"].hidden-for-location {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        height: 0 !important;
        overflow: hidden !important;
      }

      /* Styles pour le mode location sur la page produit */
      .location-mode {
        display: flex;
        flex-direction: column;
        gap: 12px;
      }

      .location-mode .greenleaze-button-product.primary-action {
        order: 1;
        background-color: #0F172A !important;
        border-color: #0F172A !important;
        color: #fff !important;
        font-size: 16px;
        padding: 14px 24px;
      }

      .location-mode .greenleaze-button-product.primary-action:hover {
        background-color: #1e293b !important;
        border-color: #1e293b !important;
      }

      .location-mode .single-add-to-cart-button.secondary-action {
        order: 2;
        background-color: transparent !important;
        color: #0F172A !important;
        border: 2px solid #0F172A !important;
      }

      .location-mode .single-add-to-cart-button.secondary-action:hover {
        background-color: rgba(15, 23, 42, 0.05) !important;
        border-color: #0F172A !important;
      }

      /* Sélecteur de durée sur page produit */
      .greenleaze-product-selector-wrapper {
        margin: 16px 0;
      }

      .hidden-for-location {
        display: none !important;
      }

      .greenleaze-product-selector {
        padding: 16px;
        background: #f9fafb;
        border: 1px solid #e5e7eb;
        border-radius: 4px;
      }

      .greenleaze-product-price-display {
        display: flex;
        align-items: baseline;
        gap: 8px;
        margin-bottom: 12px;
        min-height: 32px;
      }

      .greenleaze-product-monthly-price {
        font-size: 28px;
        font-weight: 700;
        color: #0D5537;
        line-height: 1;
      }

      .greenleaze-product-price-label {
        font-size: 16px;
        color: #666;
      }

      .greenleaze-loading {
        font-size: 16px;
        color: #999;
        font-weight: 400;
      }

      .greenleaze-product-duration-buttons {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
      }

      .greenleaze-product-duration-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        height: 32px;
        padding: 0 20px;
        border-radius: 999px;
        border: 1.5px solid #E5E7EB;
        background: #FFFFFF;
        font-weight: 500;
        font-size: 13px;
        line-height: 1;
        color: #1F2937;
        text-decoration: none;
        transition: all 0.2s ease;
        white-space: nowrap;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
        flex-shrink: 0;
        cursor: pointer;
        min-width: 70px;
        flex: 1;
      }

      .greenleaze-product-duration-btn:hover {
        background: #F3F4F6;
        border-color: #9CA3AF;
        transform: translateY(-1px);
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
      }

      .greenleaze-product-duration-btn.active {
        background: #F9FAFB;
        border-color: #D1D5DB;
        color: #374151;
      }

      .greenleaze-product-duration-btn.active:hover {
        background: #F3F4F6;
        border-color: #9CA3AF;
        transform: translateY(-1px);
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
      }

      .hidden-for-location {
        display: none !important;
      }

      @media screen and (max-width: 768px) {
        .greenleaze-product-selector-wrapper {
          margin: 12px 0;
        }

        .greenleaze-product-selector {
          padding: 12px;
        }

        .greenleaze-product-price-display {
          margin-bottom: 10px;
        }

        .greenleaze-product-monthly-price {
          font-size: 22px;
        }

        .greenleaze-product-price-label {
          font-size: 13px;
        }

        .greenleaze-product-duration-btn {
          flex: 1;
          min-width: 0;
          padding: 10px 8px;
          font-size: 13px;
        }

        .location-mode .greenleaze-button-product.primary-action {
          font-size: 15px;
          padding: 12px 20px;
        }

        /* Masquer complètement le prix original sur mobile en mode location */
        .product-price-container .price,
        .product-price-container #price-template--22342278349124__main,
        .product-price-container .no-js-hidden {
          display: none !important;
        }

        .product-price-container .installment,
        .product-price-container form[id*="installment"] {
          display: none !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  // Fonction principale d'initialisation
  function init() {
    console.log("[Greenleaze Product Page] Initializing...");
    console.log("[Greenleaze Product Page] Referrer:", document.referrer);
    console.log("[Greenleaze Product Page] Current URL:", window.location.href);

    // Marquer la session si on est sur une collection location
    markLocationSession();

    // Vérifier si on est sur une page produit
    const isProductPage =
      document.body.classList.contains("template-product") ||
      window.location.pathname.includes("/products/");

    console.log("[Greenleaze Product Page] Is product page:", isProductPage);
    console.log(
      "[Greenleaze Product Page] Body classes:",
      document.body.className,
    );

    if (!isProductPage) {
      console.log("[Greenleaze Product Page] Not a product page, skipping");
      return;
    }

    // Vérifier si l'utilisateur vient d'une collection location
    const fromLocation = isFromLocationCollection();
    console.log(
      "[Greenleaze Product Page] From location collection:",
      fromLocation,
    );

    if (!fromLocation) {
      console.log(
        "[Greenleaze Product Page] User did not come from location collection, skipping",
      );
      return;
    }

    console.log("[Greenleaze Product Page] Activating location mode...");
    console.log("[Greenleaze Product Page] Available elements:", {
      priceContainer: !!document.querySelector(".product-price-container"),
      productTitle: !!document.querySelector(".product-title"),
      addToCartButton: !!document.querySelector(".single-add-to-cart-button"),
      greenleazeButton: !!document.querySelector(".greenleaze-button-product"),
    });

    // Ajouter les styles
    addStyles();

    // Attendre que le DOM soit complètement chargé
    function applyLocationMode() {
      console.log("[Greenleaze Product Page] Applying location mode...");
      console.log("[Greenleaze Product Page] Greenleaze ready:", {
        init: window.init,
        initPrice: window.initPrice,
        hasMonthValues: !!window.monthValues,
        hasPriceRules: !!window.priceRules,
      });

      // Remplacer le prix par le sélecteur (en premier pour avoir les éléments)
      replacePriceWithSelector();

      // Réorganiser les boutons
      reorganizeProductButtons();

      // Masquer la carte de paiement en plusieurs fois
      hidePaymentInstalmentsCard();

      console.log(
        "[Greenleaze Product Page] Location mode activated successfully",
      );
    }

    // Attendre que Greenleaze soit prêt avant d'appliquer
    function waitForGreenleazeAndApply() {
      if (window.init && window.initPrice) {
        console.log(
          "[Greenleaze Product Page] Greenleaze is ready, applying now",
        );
        applyLocationMode();
      } else {
        console.log(
          "[Greenleaze Product Page] Waiting for Greenleaze to be ready...",
        );
        setTimeout(waitForGreenleazeAndApply, 300);
      }
    }

    // Écouter l'événement d'initialisation
    window.addEventListener("greenleazePriceActualize", function () {
      console.log("[Greenleaze Product Page] Greenleaze initialized via event");
      setTimeout(applyLocationMode, 200);
    });

    // Essayer immédiatement et avec retry
    setTimeout(waitForGreenleazeAndApply, 100);
    setTimeout(applyLocationMode, 2000); // Fallback après 2 secondes
  }

  // Démarrer quand le DOM est prêt
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
